import alt from "../alt";
import indexBy from "lodash/keyBy";
import SearchUtil from "../utils/SearchUtil";
import SearchActions from "../actions/SearchActions";
import UserStore from "../stores/UserStore";

class SearchStore {
  constructor() {
    this.bindActions(SearchActions);

    this.state = {
      godInfoFetched: false,
      infoFetched: false,
      config: {},
      godConfig: {},
      types: []
    };
  }

  onReset() {
    this.setState({
      infoFetched: false,
      config: {},
      types: []
    });
  }

  onFetchInfo({ godMode, typesenseMode } = {}) {
    const apiKey = UserStore.getState().apiKey;

    // Can't fetch without API key
    if (!apiKey) {
      console.log("[SearchStore] No API key; not fetching search info...");
      return;
    }

    SearchUtil.fetchInfo(apiKey, { godMode, typesenseMode })
      .then(data => {
        data.fromGodMode = !!godMode;
        SearchActions.updateInfo(data);
      })
      .catch(SearchActions.fetchFailed);
  }

  onUpdateInfo(data) {
    this.setState({
      infoFetched: data.fromGodMode ? undefined : true,
      godInfoFetched: data.fromGodMode ? true : undefined,
      config: !data.fromGodMode ? data.config : undefined,
      godConfig: data.fromGodMode ? data.config : undefined,
      types: data.types
    });
  }

  onFetchFailed(e) {
    alert(`Fetching Search data failed: ${e.message}`);
    throw e;
  }
}

export default alt.createStore(SearchStore, "SearchStore");



// WEBPACK FOOTER //
// ./src/app/stores/SearchStore.js